// ── 채팅 오버레이 다이얼로그 모음 ───────────────────
// 드라이브 첨부 선택·프롬프트 라이브러리·알림 팝업·Artifacts·새 프로젝트·프로젝트 설정·
// 웹검색 한도초과·토큰 한도초과 모달. 전부 최상위 오버레이(조건부 렌더).
// 순수 프레젠테이션: 상태·핸들러는 ChatPage에서 props로 주입(동작 100% 동일).
import { useNavigate } from 'react-router-dom';
import DrivePicker from '../../components/DrivePicker';
import { notificationPath } from '../../components/NotificationCenter';
import { stripDocMarkers } from '../../utils/docMarkers';
import { copyToClipboard } from '../../utils/clipboard';
import { IconAlertTriangle, IconBell, IconCheck, IconClipboardList, IconFileText, IconLock, IconWorld, IconX } from '@tabler/icons-react';
import { COLORS } from '../../utils/uiStyles';
import ProjectShareSection from './ProjectShareSection';

export default function ChatModals({
  showDrivePicker, setShowDrivePicker, uploadFiles, addDriveFolder, showPrompts, setShowPrompts, saveMyPrompt,
  promptQ, setPromptQ, promptList, insertPrompt, notifications, dismissNotification,
  showArtifacts, setShowArtifacts, messages, saveMsg, showNewProj, setShowNewProj,
  newProjName, setNewProjName, createProject, projModal, setProjModal, uploadProjFile,
  projFiles, deleteProjFile, saveProjSettings, deleteProject, webLimitModal, setWebLimitModal,
  setWebSearch, webLimitRequested, handleWebLimitRequest, limitModal, setLimitModal, limitRequested,
  limitReason, setLimitReason, handleLimitRequest,
}) {
  const navigate = useNavigate();
  return (
    <>
      {/* ── 드라이브 파일 선택(채팅 첨부) ── */}
      {showDrivePicker && (
        <DrivePicker onClose={() => setShowDrivePicker(false)} onPick={(file) => uploadFiles([file])} onPickFolder={addDriveFolder} />
      )}

      {showPrompts && (
        <div onClick={() => setShowPrompts(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div onClick={(e) => e.stopPropagation()}
            style={{ background: '#fff', borderRadius: '14px', width: '560px', maxWidth: '92vw', maxHeight: '78vh', display: 'flex', flexDirection: 'column', boxShadow: '0 10px 40px rgba(0,0,0,.2)' }}>
            <div style={{ padding: '14px 18px', borderBottom: '1px solid #eef0f3', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ fontSize: '15px', fontWeight: 700, color: '#1f2937', display: 'inline-flex', alignItems: 'center', gap: '6px' }}><IconClipboardList size={17} stroke={1.8} aria-hidden="true" />프롬프트 라이브러리</span>
              <button onClick={saveMyPrompt} style={{ marginLeft: 'auto', fontSize: '12px', padding: '5px 10px', border: `1px solid ${COLORS.primaryBorder}`, background: COLORS.primarySoft, color: COLORS.selectedText, borderRadius: '8px', cursor: 'pointer' }}>＋ 현재 입력 저장</button>
              <button onClick={() => setShowPrompts(false)} style={{ background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#9ca3af' }}>×</button>
            </div>
            <div style={{ padding: '10px 18px' }}>
              <input value={promptQ} onChange={(e) => setPromptQ(e.target.value)} placeholder="제목·내용·카테고리 검색…"
                style={{ width: '100%', boxSizing: 'border-box', padding: '8px 12px', border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '13px' }} />
            </div>
            <div style={{ overflowY: 'auto', padding: '0 12px 14px' }}>
              {(() => {
                const q = promptQ.trim().toLowerCase();
                const rows = promptList.filter((p) => !q || (p.title + p.body + p.category).toLowerCase().includes(q));
                if (!rows.length) return <div style={{ padding: '24px', textAlign: 'center', color: '#9ca3af', fontSize: '13px' }}>저장된 프롬프트가 없습니다.</div>;
                return rows.map((p) => (
                  <button key={p.id} onClick={() => insertPrompt(p)}
                    style={{ display: 'block', width: '100%', textAlign: 'left', padding: '10px 12px', margin: '4px 0', border: '1px solid #eef0f3', borderRadius: '10px', background: '#fff', cursor: 'pointer' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <span style={{ fontWeight: 600, fontSize: '13px', color: '#1f2937' }}>{p.title}</span>
                      {p.scope === 'shared'
                        ? <span style={{ fontSize: '10px', color: '#0369a1', background: '#e0f2fe', borderRadius: '6px', padding: '1px 6px' }}>공유</span>
                        : <span style={{ fontSize: '10px', color: '#6b7280', background: '#f1f5f9', borderRadius: '6px', padding: '1px 6px' }}>내 프롬프트</span>}
                      {p.category && <span style={{ fontSize: '11px', color: '#9ca3af' }}>· {p.category}</span>}
                    </div>
                    <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '3px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{p.body}</div>
                  </button>
                ));
              })()}
            </div>
          </div>
        </div>
      )}

      {/* ── 알림 팝업 (큐의 첫 번째만 표시) ── */}
      {notifications.length > 0 && (() => {
        const n = notifications[0];
        const isApproved = n.type === 'limit_approved';
        const meta = n.type === 'limit_approved' ? { Icon: IconCheck, title: '한도 증가 요청 승인', color: COLORS.successText }
          : n.type === 'limit_rejected' ? { Icon: IconX, title: '한도 증가 요청 거절', color: COLORS.dangerText }
          : n.type === 'budget_alert' ? { Icon: IconBell, title: '비용 예산 알림', color: COLORS.warn }
          : n.type === 'host_alert' ? { Icon: IconAlertTriangle, title: '서버 자원 경고', color: COLORS.warn }
          : { Icon: IconBell, title: '알림', color: COLORS.textSub };
        const NoticeIcon = meta.Icon;
        // «보기» = 종 아이콘과 같은 이동 규칙(notificationPath). '/' 는 지금 이 채팅 화면이라 갈 곳이 없어 두지 않는다.
        const path = notificationPath(n);
        const viewPath = path && path !== '/' ? path : null;
        const confirmPrimary = isApproved && !viewPath;
        const openNotification = async () => {
          await dismissNotification(n.id);   // 읽음 처리 먼저 — 화면을 옮기면 이 큐(ChatPage)가 사라진다
          navigate(viewPath);
        };
        return (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100 }}>
            <div style={{ background: 'white', borderRadius: '16px', padding: '32px', width: '380px', maxWidth: '90vw', boxShadow: '0 20px 60px rgba(0,0,0,.2)', textAlign: 'center' }}>
              <NoticeIcon size={42} stroke={1.7} color={meta.color} aria-hidden="true" style={{ marginBottom: '12px' }} />
              <h2 style={{ fontSize: '17px', fontWeight: '700', color: '#1f2937', marginBottom: '10px' }}>
                {meta.title}
              </h2>
              <p style={{ fontSize: '14px', color: '#6b7280', lineHeight: '1.6', marginBottom: '20px' }}>{n.message}</p>
              <div style={{ display: 'flex', gap: '8px' }}>
                {viewPath && (
                  <button onClick={openNotification}
                    style={{ flex: 1, padding: '10px', background: COLORS.primary, color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>
                    보기
                  </button>
                )}
                <button onClick={() => dismissNotification(n.id)}
                  style={{ flex: 1, padding: '10px', background: confirmPrimary ? COLORS.primary : '#f3f4f6', color: confirmPrimary ? 'white' : '#374151', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>
                  확인
                </button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── Artifacts 패널 ── */}
      {showArtifacts && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100, padding: '20px' }}>
          <div style={{ background: 'white', borderRadius: '16px', padding: '24px', width: '640px', maxWidth: '95vw', maxHeight: '85vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 60px rgba(0,0,0,.2)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
              <h2 style={{ fontSize: '17px', fontWeight: '700' }}>Artifacts</h2>
              <button onClick={() => setShowArtifacts(false)} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: '#9ca3af', lineHeight: 1 }}>×</button>
            </div>
            <p style={{ fontSize: '12px', color: '#9ca3af', margin: '0 0 12px' }}>현재 대화에서 AI가 작성한 내용입니다. 복사하거나 파일로 저장할 수 있습니다.</p>
            <div style={{ overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {messages.filter((m) => m.role === 'assistant' && m.content && m.content.trim()).length === 0 && (
                <div style={{ color: '#9ca3af', fontSize: '14px', textAlign: 'center', padding: '24px' }}>아직 생성된 내용이 없습니다.</div>
              )}
              {messages.map((m, i) => (m.role === 'assistant' && m.content && m.content.trim()) ? (
                <div key={i} style={{ border: '1px solid #e5e7eb', borderRadius: '10px', padding: '12px 14px' }}>
                  <div style={{ fontSize: '13px', color: '#374151', whiteSpace: 'pre-wrap', maxHeight: '120px', overflow: 'hidden', marginBottom: '8px', lineHeight: 1.5 }}>{stripDocMarkers(m.content).slice(0, 400)}{stripDocMarkers(m.content).length > 400 ? ' …' : ''}</div>
                  <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                    <button onClick={() => copyToClipboard(stripDocMarkers(m.content)).catch(() => {})} style={{ padding: '4px 10px', background: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', color: '#374151' }}>복사</button>
                    {[['txt', 'TXT'], ['md', 'MD'], ['docx', 'DOCX'], ['pdf', 'PDF']].map(([f, label]) => (
                      <button key={f} onClick={() => saveMsg(stripDocMarkers(m.content), f)} style={{ padding: '4px 10px', background: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', color: '#374151' }}>{label}</button>
                    ))}
                  </div>
                </div>
              ) : null)}
            </div>
          </div>
        </div>
      )}

      {/* ── 새 프로젝트 모달 ── */}
      {showNewProj && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100 }}>
          <div style={{ background: 'white', borderRadius: '16px', padding: '28px', width: '380px', maxWidth: '90vw', boxShadow: '0 20px 60px rgba(0,0,0,.2)' }}>
            <h2 style={{ fontSize: '17px', fontWeight: '700', marginBottom: '14px', color: '#1f2937' }}>새 프로젝트</h2>
            <input autoFocus value={newProjName} onChange={(e) => setNewProjName(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') createProject(); }}
              placeholder="프로젝트 이름"
              style={{ width: '100%', padding: '9px 12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', outline: 'none', boxSizing: 'border-box', marginBottom: '16px' }} />
            <div style={{ display: 'flex', gap: '8px' }}>
              <button onClick={createProject} style={{ flex: 1, padding: '10px', background: COLORS.primary, color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}>만들기</button>
              <button onClick={() => setShowNewProj(false)} style={{ flex: 1, padding: '10px', background: '#f3f4f6', color: '#374151', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>취소</button>
            </div>
          </div>
        </div>
      )}

      {/* ── 프로젝트 설정 모달 ── */}
      {projModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100, padding: '20px' }}>
          <div style={{ background: 'white', borderRadius: '16px', padding: '28px', width: '520px', maxWidth: '95vw', maxHeight: '85vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,.2)' }}>
            <h2 style={{ fontSize: '17px', fontWeight: '700', marginBottom: '16px', color: '#1f2937' }}>프로젝트 설정</h2>
            <label style={{ fontSize: '13px', fontWeight: '600', color: '#374151', display: 'block', marginBottom: '6px' }}>이름</label>
            <input value={projModal.name} onChange={(e) => setProjModal({ ...projModal, name: e.target.value })}
              style={{ width: '100%', padding: '9px 12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', outline: 'none', boxSizing: 'border-box', marginBottom: '14px' }} />
            <label style={{ fontSize: '13px', fontWeight: '600', color: '#374151', display: 'block', marginBottom: '6px' }}>프로젝트 지침</label>
            <textarea value={projModal.instructions} onChange={(e) => setProjModal({ ...projModal, instructions: e.target.value })}
              placeholder="이 프로젝트의 모든 대화에 적용할 지침(역할·말투·규칙 등)"
              rows={5}
              style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '13px', outline: 'none', boxSizing: 'border-box', resize: 'vertical', marginBottom: '16px', fontFamily: 'inherit', lineHeight: 1.6 }} />
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' }}>
              <label style={{ fontSize: '13px', fontWeight: '600', color: '#374151' }}>지식 문서</label>
              <label style={{ fontSize: '12px', color: COLORS.info, cursor: 'pointer', fontWeight: '600' }}>
                + 파일 추가
                <input type="file" onChange={uploadProjFile} style={{ display: 'none' }} accept=".pdf,.docx,.pptx,.xlsx,.txt,.csv,.md,.png,.jpg,.jpeg,.webp" />
              </label>
            </div>
            <div style={{ marginBottom: '4px', fontSize: '11px', color: '#9ca3af' }}>이미지 5MB · 문서 100MB</div>
            <div style={{ marginBottom: '8px', fontSize: '12px', color: '#9ca3af' }}>업로드한 문서 내용이 이 프로젝트 대화에 참고로 제공됩니다.</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '18px' }}>
              {projFiles.length === 0 && <div style={{ fontSize: '13px', color: '#9ca3af', padding: '8px 0' }}>첨부된 문서가 없습니다.</div>}
              {projFiles.map((f) => (
                <div key={f.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', background: '#f9fafb', borderRadius: '8px', fontSize: '13px' }}>
                  <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center', gap: '5px', minWidth: 0 }}><IconFileText size={14} stroke={1.8} aria-hidden="true" />{f.filename} <span style={{ color: '#9ca3af', fontSize: '11px' }}>({(f.chars || 0).toLocaleString()}자)</span></span>
                  <button onClick={() => deleteProjFile(f.id)} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '13px', flexShrink: 0 }}>삭제</button>
                </div>
              ))}
            </div>
            <ProjectShareSection projectId={projModal.id} role={projModal.role} />
            <div style={{ display: 'flex', gap: '8px' }}>
              <button onClick={saveProjSettings} style={{ flex: 1, padding: '10px', background: COLORS.primary, color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}>저장</button>
              <button onClick={() => setProjModal(null)} style={{ flex: 1, padding: '10px', background: '#f3f4f6', color: '#374151', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>닫기</button>
              <button onClick={deleteProject} style={{ padding: '10px 14px', background: '#fee2e2', color: '#b91c1c', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}>삭제</button>
            </div>
          </div>
        </div>
      )}

      {/* ── 웹 검색 한도 초과 모달 ── */}
      {webLimitModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', borderRadius: '16px', padding: '32px', width: '400px', maxWidth: '90vw', boxShadow: '0 20px 60px rgba(0,0,0,.2)' }}>
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <IconWorld size={42} stroke={1.7} color={COLORS.info} aria-hidden="true" style={{ marginBottom: '12px' }} />
              <h2 style={{ fontSize: '18px', fontWeight: '700', color: '#1f2937', marginBottom: '8px' }}>이번 달 웹 검색 한도 초과</h2>
              <p style={{ fontSize: '14px', color: '#6b7280', lineHeight: '1.6' }}>
                웹 검색을 끄면 일반 답변은 계속 받으실 수 있습니다.
              </p>
            </div>
            <div style={{ background: '#f9fafb', borderRadius: '8px', padding: '12px 16px', marginBottom: '20px', fontSize: '13px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                <span style={{ color: '#6b7280' }}>사용량</span>
                <span style={{ fontWeight: '600' }}>{(webLimitModal.used || 0).toLocaleString()}회</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ color: '#6b7280' }}>한도</span>
                <span style={{ fontWeight: '600' }}>{(webLimitModal.limit || 0).toLocaleString()}회</span>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '8px', marginBottom: '10px' }}>
              <button onClick={() => { setWebSearch(false); setWebLimitModal(null); }}
                style={{ flex: 1, padding: '10px', background: COLORS.primary, color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>
                웹 검색 끄고 계속
              </button>
              <button onClick={() => setWebLimitModal(null)}
                style={{ flex: 1, padding: '10px', background: '#f3f4f6', color: '#374151', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' }}>
                닫기
              </button>
            </div>
            {webLimitRequested ? (
              <div style={{ textAlign: 'center', padding: '10px', background: '#f0fdf4', borderRadius: '8px', fontSize: '13px', color: '#16a34a', fontWeight: '500' }}>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}><IconCheck size={15} stroke={2} aria-hidden="true" />관리자에게 상향 요청이 접수되었습니다.</span>
              </div>
            ) : (
              <button onClick={handleWebLimitRequest}
                style={{ width: '100%', padding: '10px', background: 'white', color: COLORS.text, border: `1px solid ${COLORS.primaryBorder}`, borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>
                관리자에게 한도 상향 요청
              </button>
            )}
          </div>
        </div>
      )}

      {/* ── 한도 초과 모달 ── */}
      {limitModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', borderRadius: '16px', padding: '32px', width: '400px', maxWidth: '90vw', boxShadow: '0 20px 60px rgba(0,0,0,.2)' }}>
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <IconLock size={42} stroke={1.7} color={COLORS.warn} aria-hidden="true" style={{ marginBottom: '12px' }} />
              <h2 style={{ fontSize: '18px', fontWeight: '700', color: '#1f2937', marginBottom: '8px' }}>이번 달 토큰 한도 초과</h2>
              <p style={{ fontSize: '14px', color: '#6b7280', lineHeight: '1.6' }}>
                이번 달 사용 가능한 토큰을 모두 소진했습니다.
              </p>
            </div>

            <div style={{ background: '#f9fafb', borderRadius: '8px', padding: '12px 16px', marginBottom: '20px', fontSize: '13px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                <span style={{ color: '#6b7280' }}>사용량</span>
                <span style={{ fontWeight: '600' }}>{(limitModal.used || 0).toLocaleString()} 토큰</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                <span style={{ color: '#6b7280' }}>한도</span>
                <span style={{ fontWeight: '600' }}>{(limitModal.limit || 0).toLocaleString()} 토큰</span>
              </div>
              <div style={{ height: '6px', background: '#e5e7eb', borderRadius: '3px' }}>
                <div style={{ width: '100%', height: '100%', background: '#ef4444', borderRadius: '3px' }} />
              </div>
            </div>

            {!limitRequested ? (
              <>
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ fontSize: '13px', color: '#374151', fontWeight: '500', display: 'block', marginBottom: '6px' }}>
                    관리자에게 한도 증가를 요청하시겠습니까?
                  </label>
                  <textarea
                    value={limitReason}
                    onChange={(e) => setLimitReason(e.target.value)}
                    placeholder="요청 사유 입력 (선택사항)..."
                    rows={3}
                    style={{ width: '100%', padding: '8px 12px', border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '13px', resize: 'none', outline: 'none', boxSizing: 'border-box' }}
                  />
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={handleLimitRequest}
                    style={{ flex: 1, padding: '10px', background: COLORS.primary, color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>
                    승인 요청
                  </button>
                  <button onClick={() => setLimitModal(null)}
                    style={{ flex: 1, padding: '10px', background: '#f3f4f6', color: '#374151', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' }}>
                    닫기
                  </button>
                </div>
              </>
            ) : (
              <>
                <div style={{ textAlign: 'center', padding: '12px', background: '#f0fdf4', borderRadius: '8px', marginBottom: '16px' }}>
                  <IconCheck size={26} stroke={2} color="#16a34a" aria-hidden="true" style={{ marginBottom: '8px' }} />
                  <p style={{ fontSize: '14px', color: '#16a34a', fontWeight: '500' }}>승인 요청이 접수되었습니다.</p>
                  <p style={{ fontSize: '13px', color: '#6b7280', marginTop: '4px' }}>관리자가 승인하면 계속 사용하실 수 있습니다.</p>
                </div>
                <button onClick={() => setLimitModal(null)}
                  style={{ width: '100%', padding: '10px', background: '#f3f4f6', color: '#374151', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' }}>
                  닫기
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
